export default __webpack_public_path__ + "static/media/SWT0870.34I-40546_-23968_0.d475d1cf.jpg";